import React from "react";
import { Paper, Stack, Typography } from "@mui/material";
import { MeetingStatus, CalendarSlot } from "../../../types";
import {
  getCalendarMeetingTypeColor,
  getCalendarMeetingTypeLabel,
} from "../../../components/calendar/calendar-status-utils";


interface MeetingsStatusFilterProps {
  cardFilter: MeetingStatus | null;
  setCardFilter: React.Dispatch<React.SetStateAction<MeetingStatus | null>>;
  totalMeetings: number;
  meetingDictionary: Record<MeetingStatus, CalendarSlot[]>;
}

const STATUS_ORDER: MeetingStatus[] = [
  MeetingStatus.Scheduled,
  MeetingStatus.Proposed,
  MeetingStatus.Training,
  MeetingStatus.Started,
  MeetingStatus.Ended,
  MeetingStatus.Abandoned,
  MeetingStatus.Cancelled,
];

const MeetingsStatusFilter: React.FC<MeetingsStatusFilterProps> = ({
  cardFilter,
  setCardFilter,
  totalMeetings,
  meetingDictionary,
}) => {
  return (
    <Stack
      sx={{
        p: 1,
        backgroundColor: "#F7F9FC",
      }}
    >
      <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
        <Paper
          elevation={0}
          onClick={() => setCardFilter(null)}
          sx={{
            px: 1.25,
            py: 0.9,
            borderRadius: 1.5,
            cursor: "pointer",
            backgroundColor: "#5A6472",
            border: cardFilter === null ? "1px solid transparent" : "1px solid rgba(0,0,0,0.16)",
            opacity: cardFilter === null ? 1 : 0.38,
            transition: "transform 0.15s ease, opacity 0.15s ease, box-shadow 0.15s ease",
            boxShadow: cardFilter === null ? "0px 2px 8px rgba(0,0,0,0.12)" : "none",
            userSelect: "none",
            "&:hover": {
              opacity: cardFilter === null ? 0.92 : 0.6,
              transform: "translateY(-1px)",
            },
          }}
        >
          <Typography
            sx={{
              color: "#FFFFFF",
              fontSize: "0.75rem",
              fontWeight: 700,
              lineHeight: 1,
            }}
          >
            {`ALL (${totalMeetings})`}
          </Typography>
        </Paper>

        {STATUS_ORDER.map((status) => {
          const active = cardFilter === status;
          const label = getCalendarMeetingTypeLabel(status).toUpperCase();

          return (
            <Paper
              key={status}
              elevation={0}
              onClick={() => setCardFilter(status)}
              sx={{
                px: 1.25,
                py: 0.9,
                borderRadius: 1.5,
                cursor: "pointer",
                backgroundColor: getCalendarMeetingTypeColor(status),
                border: active ? "1px solid transparent" : "1px solid rgba(0,0,0,0.16)",
                opacity: active ? 1 : 0.38,
                transition: "transform 0.15s ease, opacity 0.15s ease, box-shadow 0.15s ease",
                boxShadow: active ? "0px 2px 8px rgba(0,0,0,0.12)" : "none",
                userSelect: "none",
                "&:hover": {
                  opacity: active ? 0.92 : 0.6,
                  transform: "translateY(-1px)",
                },
              }}
            >
              <Typography
                sx={{
                  color: "#FFFFFF",
                  fontSize: "0.75rem",
                  fontWeight: 700,
                  lineHeight: 1,
                }}
              >
                {`${label} (${meetingDictionary[status].length})`}
              </Typography>
            </Paper>
          );
        })}
      </Stack>
    </Stack>
  );
};

export default MeetingsStatusFilter;